import { ICON__copy } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { HOOK_GENERATION__notifier } from '@/pages/page_generation/view_header/_buttons/button_generation/_hooks/HOOK_GENERATION__notifier';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { REMOTE__generation_create } from '@/state/generation/entity/REMOTE__generation_create';
import { set_current_generation } from '@/utils/utils_client_workspace_child_entity_viewers';
import { assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO_REQUEST__generation_create } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create';
import { useTranslation } from 'react-i18next';

export function G_BUTTON__generation_clone() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { notifier } = HOOK_GENERATION__notifier(ENUM__component_type.PAGE_GENERATION_BUTTON_GENERATION_CONTINUE);

  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let request = DTO_REQUEST__generation_create.CREATE_FOR_CLONE(generation_current);

    /*
     *
     */
    let action_result = await dispatch(REMOTE__generation_create(request));

    if (typeof action_result.payload != 'string') return;

    let generation_id = action_result.payload;

    assert_string_object_id(generation_id);

    await set_current_generation(generation_id);
  }

  /*
   * HTML
   */

  return (
    <>
      <UI_PRIMITIVE__button {...{ onClick }} {...{ notifier }} className="info__button_generation_clone" size="full" variant={'no-border-on-component'}>
        <ICON__copy className="!size-5" />
      </UI_PRIMITIVE__button>
    </>
  );
}
